var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('home-header',{on:{"Collapse":_vm.trsCollapse}}),_vm._v(" "),_c('home-sidebar',{attrs:{"collapse":_vm.isCollapse}}),_vm._v(" "),_c('div',{staticClass:"content",class:{'content-collapse':_vm.isCollapse}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a846738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 